module.exports = __webpack_public_path__ + "img/hugo2.6d70abf5.jpg";